import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

const DEFAULT_SEARCH_DEBOUNCE = 400;

@Component({
    selector: 'syn-filter-bar',
    templateUrl: './filter-bar.component.html',
    styleUrls: ['./filter-bar.component.scss']
})
export class FilterBarComponent implements OnInit, OnDestroy {
    @Input() searchPlaceholder = 'Rechercher';
    @Input() showToggle = true;
    @Input() toggleLabel = '';
    @Input() toggleValue = false;
    @Input() searchDebounce = DEFAULT_SEARCH_DEBOUNCE;

    @Output() filterChange = new EventEmitter<{searchFilter: string; input?: MatInput}>();
    @Output() toggleChange = new EventEmitter<boolean>();

    public query = '';

    private filterChangeWithDebounce$ = new Subject<{searchFilter: string; input?: MatInput}>();
    private filterChangeSub?: Subscription;

    constructor() { }

    ngOnInit(): void {
        this.filterChangeSub = this.filterChangeWithDebounce$
            .pipe(debounceTime(this.searchDebounce))
            .subscribe(payload => this.filterChange.emit(payload));
    }

    ngOnDestroy(): void {
        this.filterChangeSub?.unsubscribe();
    }

    applyFilter(searchFilter: string, input?: MatInput): void {
        this.query = searchFilter.trim().toLowerCase();
        this.filterChangeWithDebounce$.next({searchFilter, input});
    }

    onToggleChange(isChecked: boolean): void {
        this.toggleChange.emit(isChecked);
    }
}
